import React, { useState, useEffect } from 'react';
import {
  Lock, Shield, Key, FileText, AlertCircle, Clock,Check, Search, Bell, AlertTriangle, User,
  ChevronLeft, ChevronRight, Moon, Sun, Download,Database, ChevronDown, Settings, RefreshCcw,
  CheckCircle, XCircle, LogOut, Trash2, Fish, Copy
} from 'lucide-react';
import { API_ENDPOINTS, postDataWithFiles } from '../../services/api'; 
import axios from 'axios';
import Avatar from '../../services/Avatar';


const EncryptionDashboard = () => {
  const [darkMode, setDarkMode] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [encryptionMode, setEncryptionMode] = useState('text');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [isCopiedInput, setIsCopiedInput] = useState(false);
  const [isCopiedOutput, setIsCopiedOutput] = useState(false);
  const [inputText, setInputText] = useState('');
  const [filePreview, setFilePreview] = useState("");
  const [currentUser, setCurrentUser] = useState(null);

  const [fileType, setFileType] = useState('');
  const [textColor, setTextColor] = useState('');
  const [outputText, setOutputText] = useState('');
  const [operation, setOperation] = useState(''); // Keep as a separate variable if desired
  const [keyManagement, setKeyManagement] = useState(''); // Same here
  const [digitalSignature, setDigitalSignature] = useState(''); // For Digital Signatures  
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState(''); // 'success', 'error', 'info'
  const [borderColor, setBorderColor] = useState('');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [password, setPassword] = useState('');
  
    
  const [showNotifications, setShowNotifications] = useState(false);
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [activeSession, setActiveSession] = useState(true);
  const [processingStatus, setProcessingStatus] = useState(null);

    const keyManagementRequiresPassword = ['derive_password', 'derive_key', 'hash_password', 'derive_key_scrypt', 'wrap_key', 'unwrap_key', 'encrypt_key', 'decrypt_key'];
  const [error, setError] = useState({
    algorithm: false,
    scope: false,
    content: false,
  });
  const [settings, setSettings] = useState({
    algorithm: '',
    authentication: '',
    integrity: '',
    scope: 'Text',
    keyManagement: '',   
    operation: '',
    digitalSignature: ''
  });

  useEffect(() => {
    if (alertMessage) {
        const timer = setTimeout(() => {
            setAlertMessage('');
        }, 7000); // 7 seconds duration

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }
}, [alertMessage]);


      useEffect(() => {
        const controller = new AbortController();
        const fetchUserProfile = async () => {
            try {
                const response = await axios.get('/users/me', { 
                    withCredentials: true,
                    signal: controller.signal // Attach signal to cancel duplicate requests
                });
                setCurrentUser(response.data);
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled:', error.message);
                } else {
                    console.error('Error fetching user profile:', error);
                }
            }
        };
    
        fetchUserProfile();
    
        return () => controller.abort(); 
    }, []);

const Skeleton = ({ width = "w-8", height = "h-8", rounded = "rounded-full" }) => (
  <div className={`${width} ${height} ${rounded} bg-gray-300 animate-pulse`} />
);

// Map operations to display messages
const operationMessages = {
  encryption: '🔐 Encrypt ',          
  decryption: '🔑 Decrypt ',
  default: '🔍 Set Operation',
};

const buttonClass = operation ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-600 hover:bg-gray-700 cursor-not-allowed';


const handleLogout = async () => {
  try {
    const response = await fetch('/d-auth/logout', {
      method: 'POST', // or 'GET', depending on your backend implementation
      credentials: 'include', // include cookies with the request
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {       
      
      window.location.href = '/'; 
    } else {
      // If there's an error during logout
      const errorData = await response.json();
      //console.error('Logout failed', errorData);
      alert( errorData ||'Logout failed. Please try again.');
    }
  } catch (error) {
    //console.error('Error during logout:', error);
    alert('An error occurred. Please try again.');
  }
};

  // Sample encryption logs
  const [encryptionLogs, setEncryptionLogs] = useState([]); 


  // Modal Component
 
  const PasswordModal = ({ isOpen, onClose, onSubmit }) => {
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState('');
  
    const evaluateStrength = (password) => {
      if (password.length >= 12 && /[A-Z]/.test(password) && /\d/.test(password) && /[@$!%*?&#]/.test(password)) {
        return 'Strong';
      } else if (password.length >= 8 && (/[A-Z]/.test(password) || /\d/.test(password) || /[@$!%*?&#]/.test(password))) {
        return 'Medium';
      } else {
        return 'Weak';
      }
    };
  
    const handlePasswordChange = (e) => {
      const newPassword = e.target.value;
      setPassword(newPassword);
      setPasswordStrength(evaluateStrength(newPassword));
    };
  
    const handleGeneratePassword = () => {
      const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$!%*?&#';
      let generatedPassword = '';
      for (let i = 0; i < 12; i++) {
        generatedPassword += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      setPassword(generatedPassword);
      setPasswordStrength(evaluateStrength(generatedPassword));
    };
  
    const handleSubmit = () => {
      onSubmit(password);
      setPassword(''); 
      setPasswordStrength('');
      onClose(); 
    };
  
    const getBorderColor = () => {
      if (passwordStrength === 'Strong') return 'border-green-500';
      if (passwordStrength === 'Medium') return 'border-yellow-500';
      return 'border-red-500';
    };
  
    return (
      isOpen ? (
        <div className="fixed inset-0 z-50">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black opacity-50"></div>
          
          {/* Modal */}
          <div className="fixed inset-0 flex items-center justify-center">
            <div className="bg-gray-800 text-white rounded-lg shadow-lg p-6 w-96">
              <h2 className="text-lg font-semibold mb-4">Enter Password</h2>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={handlePasswordChange}
                  className={`w-full p-3 rounded border ${getBorderColor()} bg-gray-700 text-white`}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-3 text-gray-400 hover:text-gray-200"
                >
                  {showPassword ? '🙈' : '👁️'}
                </button>
              </div>
              <p className={`mt-2 text-sm ${
                passwordStrength === 'Strong' ? 'text-green-400' :
                passwordStrength === 'Medium' ? 'text-yellow-400' : 'text-red-400'
              }`}>
                Password Strength: {passwordStrength || 'Enter password'}
              </p>
              <button
                type="button"
                onClick={handleGeneratePassword}
                className="bg-blue-600 text-white px-4 py-2 rounded mt-4 w-full"
              >
                Generate Strong Password
              </button>
              <div className="flex justify-end mt-4">
                <button
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  className="ml-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
                  onClick={onClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null
    );
  };
  

  const SupportedFileTypes = {
    TEXT: 'text/plain',
    IMAGE: 'image/jpeg',
    IMAGE_PNG: 'image/png',
    IMAGE_GIF: 'image/gif',
    PDF: 'application/pdf',
    DOC: 'application/msword',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    XLS: 'application/vnd.ms-excel',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    CSV: 'text/csv',
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const type = file.type;

      setSelectedFile(file);

      // Reset previous file content and types
      setFileContent('');
      setFileType('');
      setError({ content: false });

      reader.onload = (e) => {
        if (type.startsWith('image/')) {
          setFileType('image');
          setFileContent(e.target.result);
        } else if (type === SupportedFileTypes.TEXT) {
          setFileType('text');
          setFileContent(e.target.result);
        } else if (type === SupportedFileTypes.PDF) {
          setFileType('pdf');
          setFileContent(e.target.result);
        } else {
          setError({ content: true }); 
        }
      };

      if (type.startsWith('image/')) {
        reader.readAsDataURL(file);
      } else if (type === SupportedFileTypes.TEXT) {
        reader.readAsText(file);
      } else if (type === SupportedFileTypes.PDF) {
        reader.readAsDataURL(file);
      } else {
        setError({ content: true }); 
      }
    } else {
      setSelectedFile(null);
      setFileContent('');
      setFileType('');
      setError({ content: true });
    }
  };

  const handleEncryptionModeChange = (e) => {
    const mode = e.target.value;
    setEncryptionMode(mode);
  
    // Clear the input and file state when switching modes
    if (mode === 'text') {
      setSelectedFile(null); // Clear selected file
    } else if (mode === 'file') {
      setInputText(''); // Clear input text
    }
  };

  // Handle key management change
  const handleKeyManagementChange = (e) => {
      const selectedValue = e.target.value;
      setKeyManagement(selectedValue);

      // Check if the selected action requires a password
      if (keyManagementRequiresPassword.includes(selectedValue)) {
          setShowPasswordModal(true);
      } else {
          setShowPasswordModal(false); 
      }
  };

  const handlePasswordSubmit = (password) => {
      setPassword(password);
    
      console.log('Password submitted:', password);
     
  };

  


  
   
  const handleSubmit = async () => {
    // Validate each of the fields and set error states
    const newErrorState = {
        algorithm: settings.algorithm === '',
        keyManagement: keyManagement === '',
        operation: operation === '',
        scope: encryptionMode === '',
        content: encryptionMode === 'text' ? inputText.trim() === '' : selectedFile === null,
    };

    setError(newErrorState);

    // Check for any errors and exit if any exist
    if (Object.values(newErrorState).some(err => err)) {
        return;  
    }

    // Record start time
    const startTime = performance.now();

    const dataToSend = {
        algorithm: settings.algorithm,
        keyManagement: keyManagement,
        integrity: settings.integrity,
        scope: encryptionMode,
        operation: operation,
        password: password,
        digital_signature: digitalSignature,
        authentication: settings.authentication,
        content: encryptionMode === 'file' ? await encodeFile(selectedFile) : inputText,
        fileType: encryptionMode === 'file' ? selectedFile.type : undefined,
        fileName: encryptionMode === 'file' ? selectedFile.name : undefined
    };

    try {
        const response = await postDataWithFiles(dataToSend);        

        // Record end time and calculate duration
        const endTime = performance.now();
        const duration = `${((endTime - startTime) / 1000).toFixed(2)} sec`; 

        // Calculate the size
        let size = 'N/A';
        if (encryptionMode === 'text') {
            size = `${(new TextEncoder().encode(inputText).length / 1024).toFixed(2)} KB`;
        } else if (selectedFile) {
            size = `${(selectedFile.size / 1024).toFixed(2)} KB`;
        }

        if (response.error) {
            setOutputText(response.error);
            setAlertMessage('Error: ' + response.error);
            setAlertType('danger');
            setBorderColor('border-red-500'); 
            setTextColor('text-red-500');

            // Add an error log
            addLog(settings.algorithm, operation, 'Text', 'error', response.error, size, duration);
        } else {
            setOutputText(response.result);
            setAlertMessage('Operation successful!');
            setAlertType('success');
            setBorderColor('border-green-300'); 
            setTextColor('text-green-400'); 

            const logType = encryptionMode === 'file' ? 'File' : 'Text';

           
            addLog(settings.algorithm, operation, logType, 'success', response.result, size, duration);
        }
    } catch (error) {
        console.log("Fetch error:", error);
        setAlertMessage('Error: ' + error.message);
        setAlertType('warning');
        setBorderColor('border-yellow-500'); 
        setTextColor('text-yellow-400'); 

     
        addLog(settings.algorithm, operation, 'Text', 'error', error.message, 'N/A', 'N/A');
    }
};


const addLog = (algorithm, operation, type, status, message, size, duration) => {
  
    const timestamp = new Date().toLocaleString(); 
    const newLog = {
        id: Date.now(), 
        timestamp,
        algorithm,  
        operation,  
        type,
        status,
        size,
        duration: duration || 'N/A',
        message: message 
    };

    setEncryptionLogs(prevLogs => {
        const updatedLogs = [newLog, ...prevLogs]; 
        return updatedLogs.slice(0, 4);  
    });
};




  const encodeFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(btoa(reader.result));
      reader.onerror = () => reject(reader.error);
      reader.readAsBinaryString(file);
    });
  };

  const handleCopy = (text, setIsCopied) => {
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000); 
    });
  };

  const handleDownload = () => {
    // Determine the new file name based on operation
    const newFileName = encryptionMode === 'file' 
      ? `${selectedFile.name.replace(/\.[^/.]+$/, "")}_${operation === 'encryption' ? 'encrypted' : 'decrypted'}${selectedFile.name.match(/\.[^/.]+$/)}` // Preserve original extension
      : `Cout_${operation === 'encryption' ? 'encrypted' : 'decrypted'}.txt`; 

    const blob = encryptionMode === 'file' 
      ? new Blob([outputText], { type: selectedFile.type }) 
      : new Blob([outputText], { type: 'text/plain' }); 

    // Create a link element
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = newFileName;

    
    document.body.appendChild(link);
    link.click();

   
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };



  const renderOperationAndKeyManagement = () => (
    <div className="bg-gray-800 p-6 rounded-lg">
      {/* Encryption/Decryption Selection */}
      <div className="space-y-2 mb-4">
        <label className="block text-sm font-medium">Operation</label>
        <select
          className={`w-full bg-gray-700 rounded-lg p-2 ${error.operation ? "border-2 border-red-500" : ""}`}
          value={operation}
          onChange={(e) => setOperation(e.target.value)}
        >
          <option value="">Select Operation</option>
          <option value="encryption">Encryption</option>
          <option value="decryption">Decryption</option>
        </select>
        {error.operation && <span className="text-red-500 text-sm">Operation is required.</span>}
      </div>

      {/* Key Management */}
      <div className="space-y-2 mb-4">
        <label className="block text-sm font-medium">Key Management</label>
        <select
          className="w-full bg-gray-700 rounded-lg p-2"
          value={keyManagement}
          onChange={handleKeyManagementChange}
        >
          <option value="">Select Key Management Action</option>
          <option value="generate_key">Generate Key</option>{/*
          <option value="derive_password">Derive Password (PBKDF2)</option>
          <option value="derive_key">Derive Key (Argon2)</option>
          <option value="hash_password">Hash Password (Bcrypt)</option>
          <option value="derive_key_scrypt">Derive Key (Scrypt)</option>
          <option value="wrap_key">Wrap Key (AES Key Wrap)</option>
          <option value="unwrap_key">Unwrap Key (AES Key Wrap)</option>
          <option value="encrypt_key">Encrypt Key (PKCS#7)</option>
          <option value="decrypt_key">Decrypt Key (PKCS#7)</option>*/}
        </select>
        {error.keyManagement && <span className="text-red-500 text-sm">Key Management is required.</span>}
      </div>

      {/* Password Modal */}
      <PasswordModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSubmit={handlePasswordSubmit}
      />

      {/* Digital Signatures */}
      <div className="space-y-2 mb-4">
        <label className="block text-sm font-medium">Digital Signatures</label>
        <select
          className="w-full bg-gray-700 rounded-lg p-2"
          value={digitalSignature}
          onChange={(e) => setDigitalSignature(e.target.value)}
        >
          <option value="">Select Signature Scheme</option>
          <option value="ecdsa">ECDSA (Elliptic Curve Digital Signature Algorithm)</option>
          <option value="ed25519">Ed25519</option>
          <option value="rsa_pss">RSA-PSS (Probabilistic Signature Scheme)</option>
        </select>
      </div>
    </div>
  );

  const renderOutputSection = () => (
    <div className={`bg-gray-800 p-6 rounded-lg border ${borderColor}`}>
      <h3 className="text-lg font-semibold mb-3 flex justify-between items-center">
        Output
        <div className="flex space-x-2">
          <button
            className="p-2 hover:bg-gray-700 rounded-lg"
            onClick={() => handleCopy(outputText, setIsCopiedOutput)}
          >
            {isCopiedOutput ? <Check className="w-5 h-5 text-green-500" /> : <Copy className="w-5 h-5" />}
          </button>
          <button 
            className="p-2 hover:bg-gray-700 rounded-lg" 
            onClick={handleDownload} 
          >
            <Download className="w-5 h-5" />
          </button>
        </div>
      </h3>
      <div className={`w-full h-48 bg-gray-700 rounded-lg p-3 overflow-auto ${textColor}`}>
        <code>{outputText}</code>
      </div>
    </div>
  );


  return (
    <div className={`min-h-screen flex ${darkMode ? 'dark bg-gray-900 text-white' : 'bg-white text-gray-900'}`}>
      {/* Sidebar */}
      <div className={`relative transition-all duration-300 ${sidebarCollapsed ? 'w-16' : 'w-64'}
          bg-gray-800 dark:bg-gray-800 flex-shrink-0 flex flex-col`}>
        <div className="p-4 space-y-4">
          <div className="flex items-center space-x-3 p-2 bg-blue-600 rounded-lg">
            <Lock className="h-5 w-5" />
            {!sidebarCollapsed && <span>Cryptography</span>}
          </div>
          <div className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded-lg">
            <Trash2 className="h-5 w-5" />
            {!sidebarCollapsed && <span>Secure Deletion</span>}
          </div>
          <div className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded-lg">
            <Fish className="h-5 w-5" />
            {!sidebarCollapsed && <span>Phishing Analysis</span>}
          </div>
        </div>
        {/* Toggle Button */}
        <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className={`absolute top-16 ${sidebarCollapsed ? 'right-[-16px]' : 'right-[-32px]'} bg-gray-700 rounded-full p-1 transition-all`}
        >
          {sidebarCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </button>
      </div>

      {/* Main Content */}
     {/* Enhanced Navigation */}
     <div className="flex-1 flex flex-col">
     <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            {/* Left Section */}
            <div className="flex items-center space-x-8">
              <div className="flex items-center space-x-3">
                <Shield className="h-8 w-8 text-blue-500" />
                <div>
                  <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                    CryptoVault Pro
                  </h1>
                  <span className="text-xs text-gray-400">Enterprise Edition v2.4.1</span>
                </div>
              </div>
              
              {/* Quick Actions */}
              <div className="hidden md:flex items-center space-x-4">
                <button className="px-3 py-1.5 bg-gray-700 rounded-lg text-sm flex items-center space-x-2 hover:bg-gray-600">
                  <Key size={16} />
                  <span>Key Management</span>
                </button>
                <button className="px-3 py-1.5 bg-gray-700 rounded-lg text-sm flex items-center space-x-2 hover:bg-gray-600">
                  <Database size={16} />
                  <span>Vault Access</span>
                </button>
              </div>
            </div>

            {/* Right Section */}
            <div className="flex items-center space-x-6">
              {/* Search */}
              <div className="hidden md:flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search operations..."
                    className="w-64 bg-gray-700 rounded-lg pl-10 pr-4 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                  />
                  <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
                </div>
              </div>

              {/* System Status */}
              <div className="flex items-center space-x-2 text-sm">
                <div className="flex items-center">
                  <div className={`w-2 h-2 rounded-full ${activeSession ? 'bg-green-500' : 'bg-red-500'} mr-2`}></div>
                  <span className="text-gray-400">System Status</span>
                </div>
              </div>

              {/* Notifications */}
              <div className="relative">
                <button 
                  className="p-2 rounded-lg hover:bg-gray-700 relative"
                  onClick={() => setShowNotifications(!showNotifications)}
                >
                  <Bell className="h-5 w-5" />
                  <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                </button>
                
                {showNotifications && (
                  <div className="absolute right-0 mt-2 w-80 bg-gray-800 rounded-lg shadow-lg border border-gray-700 py-2">
                    <div className="px-4 py-2 border-b border-gray-700">
                      <h3 className="font-semibold">Notifications</h3>
                    </div>
                    <div className="max-h-96 overflow-y-auto">
                      {/* Notification Items */}
                      <div className="px-4 py-3 hover:bg-gray-700 cursor-pointer">
                        <div className="flex items-start">
                          <AlertTriangle className="h-5 w-5 text-yellow-500 mt-1 mr-3" />
                          <div>
                            <p className="text-sm font-medium">New Security Update Available</p>
                            <p className="text-xs text-gray-400 mt-1">Version 2.4.2 includes critical security patches</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Settings and Profile */}
              <div className="flex items-center space-x-4">
                
                
                <div className="relative">
                    <button 
                    className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-700"
                    onClick={() => setShowAdvancedSettings(!showAdvancedSettings)}
                  >
                    <div className="w-8 h-8 rounded-full bg-gradient-to-r from-blue-400 to-purple-500 flex items-center justify-center overflow-hidden">
                      {currentUser ? (
                                            <>
                                              <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                                            </>
                                          ) : (
                                            <div className="flex items-center gap-2">
                                              <Skeleton width="w-10 h-10" rounded="rounded-full" /> {/* Skeleton for Avatar */}
                                              <div className="flex flex-col">
                                                <Skeleton width="w-20" height="h-3" rounded="rounded-md" /> {/* Skeleton for Name */}
                                                <Skeleton width="w-16" height="h-3" rounded="rounded-md" /> {/* Skeleton for Role */}
                                              </div>
                                            </div>
                                          )}
                    </div>
                    <ChevronDown className="h-4 w-4 text-gray-400" />
                  </button>

                  {showAdvancedSettings && (
                    <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-lg border border-gray-700">
                      <div className="flex items-center space-x-3">
                                          {currentUser ? (
                                            <>
                                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-white text-sm font-medium">
                                                <Avatar firstName={currentUser.first_name} lastName={currentUser.last_name} />
                                              </div>
                                              <div>
                                                <span className="text-sm text-gray-100 font-medium">{currentUser.first_name} {currentUser.last_name}</span>
                                                <span className="text-xs text-gray-400">{currentUser.role}</span>
                                              </div>
                                            </>
                                          ) : (
                                            <div className="flex items-center gap-2">
                                              <Skeleton width="w-10 h-10" rounded="rounded-full" /> {/* Skeleton for Avatar */}
                                              <div className="flex flex-col">
                                                <Skeleton width="w-20" height="h-3" rounded="rounded-md" /> {/* Skeleton for Name */}
                                                <Skeleton width="w-16" height="h-3" rounded="rounded-md" /> {/* Skeleton for Role */}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                      <div className="py-2">
                        <button className="w-full px-4 py-2 text-left text-sm hover:bg-gray-700 flex items-center">
                          <Settings className="h-4 w-4 mr-3" />
                          <span>Settings</span>
                        </button>
                        <button 
                          className="w-full px-4 py-2 text-left text-sm hover:bg-gray-700 flex items-center text-red-400"
                          onClick={handleLogout}
                        >
                          <LogOut className="h-4 w-4 mr-3" />
                          <span>Sign Out</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb and Status Bar */}
      <div className="fixed top-16 left-0 right-0 bg-gray-800 border-b border-gray-700 z-40">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-12">
            <div className="flex items-center space-x-2 text-sm text-gray-400">
              <span>Dashboard</span>
              <span>/</span>
              <span>Encryption</span>
              <span>/</span>
              <span className="text-gray-100">New Operation</span>
            </div>
            
            {processingStatus && (
              <div className="flex items-center space-x-2">
                <RefreshCcw className="h-4 w-4 animate-spin text-blue-400" />
                <span className="text-sm text-blue-400">{processingStatus}</span>
              </div>
            )}
          </div>
        </div>
     </div>
  
        {/* Main Content Area */} 

      

        {/* Content Area */}
        <div className="pt-16 flex-1">
        <div className="p-6 bg-gray-800 m-6 rounded-lg">
          <h2 className="text-xl font-bold mb-4">Encryption Parameters</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            
            {/* Algorithm Selection */}
            <div className="space-y-2">
              <label className="block text-sm font-medium">Algorithm</label>
              <select
                className={`w-full bg-gray-700 rounded-lg p-2 ${error.algorithm ? 'border-2 border-red-500' : ''}`} // Add error border class
                value={settings.algorithm}
                onChange={(e) => setSettings({ ...settings, algorithm: e.target.value })}
              >
                <option value="">Select an Algorithm</option>
                <optgroup label="Symmetric Algorithms">
                  <option value="AES_128">AES-128</option>
                  <option value="AES_192">AES-192</option>
                  <option value="AES_256">AES-256</option>
                  <option value="DES">DES</option>
                  <option value="Blowfish">Blowfish</option>                 
                  <option value="Camellia">Camellia</option>
                  <option value="XOR">XOR</option>
                </optgroup>
                <optgroup label="Asymmetric Algorithms">
                  <option value="RSA_1024">RSA-1024</option>
                  <option value="RSA_2048">RSA-2048</option>
                  <option value="RSA_4096">RSA-4096</option>                
                </optgroup>
                {/*}
                <optgroup label="Key Exchange Algorithms">
                  <option value="Diffie-Hellman">Diffie-Hellman</option>
                </optgroup>*/}
              </select>
              {error.algorithm && <span className="text-red-500 text-sm">Algorithm is required.</span>}
            </div>

            {/* Authentication Selection */}
            <div className="space-y-2">
              <label className="block text-sm font-medium">Authentication</label>
              <select
                className="w-full bg-gray-700 rounded-lg p-2"
                value={settings.authentication}
                onChange={(e) => setSettings({ ...settings, authentication: e.target.value })}
              >
                <option value="">Select Auth</option>
                <optgroup label="Password-based">
                  <option value="password">Password</option>
                  <option value="password_hash">Password Hash</option>
                  <option value="password_salted">Password with Salt</option>
                </optgroup>{/*
                <option value="certificate">Certificate-based</option>
                <option value="key_pair">Key Pair</option>
                <option value="biometric">Biometric</option>
                <option value="multi_factor">Multi-factor Authentication</option>*/}
              </select>
            </div>

            {/* Integrity Check Selection */}
            <div className="space-y-2">
              <label className="block text-sm font-medium">Integrity Check</label>
              <select
                className="w-full bg-gray-700 rounded-lg p-2"
                value={settings.integrity}
                onChange={(e) => setSettings({ ...settings, integrity: e.target.value })}
              >
                <option value="">Select Integrity</option>
                <option value="sha256">SHA-256</option>
                <option value="sha512">SHA-512</option>
                <option value="md5">MD5</option>
                <option value="ripemd160">RIPEMD-160</option>
                <option value="sha3_256">SHA3-256</option>
                <option value="blake2s">BLAKE2s</option>
              </select>
            </div>

            {/* Encryption Scope Selection */}
            <div className="space-y-2">
              <label className="block text-sm font-medium">Encryption Scope</label>
              <select
                className={`w-full bg-gray-700 rounded-lg p-2 ${error.scope ? 'border-2 border-red-500' : ''}`} // Red border on error
                value={encryptionMode}
                onChange={handleEncryptionModeChange} 
              >
                <option value="text">Text Input</option>
                <option value="file">File Input</option>
              </select>
              {error.scope && <span className="text-red-500 text-sm">Scope is required.</span>}
            </div>
          </div>          
        </div>

        {/* Encryption Interface */}
        <div className="p-6">
        {encryptionMode === "text" ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Input Section */}
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-3 flex justify-between items-center">
                Input Text
                <button
                  className="p-2 hover:bg-gray-700 rounded-lg"
                  onClick={() => handleCopy(inputText, setIsCopiedInput)}
                >
                  {isCopiedInput ? <Check className="w-5 h-5 text-green-500" /> : <Copy className="w-5 h-5" />}
                </button>
              </h3>
              <textarea
                className={`w-full h-48 bg-gray-700 rounded-lg p-3 ${
                  error.content && encryptionMode === "text" ? "border-2 border-red-500" : ""
                }`}
                placeholder="Enter text to encrypt..."
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
              />
              {error.content && encryptionMode === "text" && (
                <span className="text-red-500 text-sm">Text input is required.</span>
              )}
            </div>

            {/* Operation and Key Management Section */}
            {renderOperationAndKeyManagement()}

            {/* Output Section */}
            {renderOutputSection()}
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* File Input Section */}
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-3 flex justify-between items-center">
                Upload File
                <button
                  className="p-2 hover:bg-gray-700 rounded-lg"
                  onClick={() => handleCopy(selectedFile ? selectedFile.name : "", setIsCopiedInput)}
                >
                  {isCopiedInput ? <Check className="w-5 h-5 text-green-500" /> : <Copy className="w-5 h-5" />}
                </button>
              </h3>
              <div className="border-2 border-dashed border-gray-600 rounded-lg p-8 text-center relative">
                <input
                  type="file"
                  onChange={handleFileSelect}
                  className="hidden"
                  id="file-upload"
                />
                <label
                  htmlFor="file-upload"
                  className="cursor-pointer flex flex-col items-center"
                >
                  <FileText className="h-12 w-12 text-blue-500 mb-4" />
                  <span className="text-sm">Drop files here or click to upload</span>
                </label>
                {selectedFile && (
                  <div className="mt-4 text-sm">
                    Selected: {selectedFile.name}
                  </div>
                )}
                {error.content && (
                  <span className="text-red-500 text-sm mt-2">Unable to preview this file. Please upload a valid file type: (text, image, PDF, DOC, DOCX, XLS, XLSX, CSV).</span>
                )}
                {error.content && encryptionMode === 'file' && <span className="text-red-500 text-sm">Please upload a file.</span>}
                <div className="mt-4" style={{ maxHeight: '200px', overflow: 'auto' }}>
                  {fileType === 'text' && (
                    <textarea
                      rows={10}
                      value={fileContent}
                      readOnly
                      className="w-full p-2 border border-gray-600 rounded-lg"
                    />
                  )}
                  {fileType === 'image' && (
                    <img src={fileContent} alt="Uploaded" className="max-w-full h-auto" style={{ maxHeight: '200px' }} />
                  )}
                  {fileType === 'pdf' && (
                    <iframe src={fileContent} title="Uploaded PDF" className="w-full h-48" />
                  )}
                </div>
              </div>
            </div>

            {/* Operation and Key Management Section */}
            {renderOperationAndKeyManagement()}

            {/* Output Section */}
            {renderOutputSection()}
          </div>
        )}
         <div className="mt-6 flex justify-center">
            <button
              disabled={!operation} // Disable button if no operation is selected
              onClick={() => {
                handleSubmit(); // Handle submit for the collected data
              }}
              className={`${buttonClass} px-6 py-2 rounded-lg flex items-center space-x-2`}
            >
              <Lock className="h-4 w-4" />
              <span>
                {operationMessages[operation] || operationMessages.default}
              </span>
            </button>
          </div>
      </div>


        <div className="relative">
            {alertMessage && (
                <div 
                    className={`alert alert-${alertType} mb-4 fixed right-0 top-0 m-4 p-3 rounded ${
                        alertType === 'success' ? 'bg-green-200 text-green-800' :
                        alertType === 'danger' ? 'bg-red-200 text-red-800' :
                        'bg-yellow-200 text-yellow-800'
                    }`} 
                    style={{ zIndex: 1000 }}
                >
                    {alertMessage}
                </div>
            )}            
        </div>

        
            {/* Summary and Logs */}
            <div className="p-6">
              <div className="bg-gray-800 rounded-lg p-6">
                  <h2 className="text-xl font-bold mb-4">Activity Logs</h2>
                  <div className="overflow-x-auto">
                      <table className="w-full table-fixed"> {/* Apply table-fixed */}
                          <thead>
                              <tr className="text-left border-b border-gray-700">
                                  <th className="p-3 w-12">#</th> 
                                  <th className="p-3 w-40">Timestamp</th>
                                  <th className="p-3 w-28">Algorithm</th> 
                                  <th className="p-3 w-28">Operation</th>  
                                  <th className="p-3 w-28">Type</th>
                                  <th className="p-3 w-32">Status</th>
                                  <th className="p-3 w-20">Size</th>
                                  <th className="p-3 w-20">Duration</th>
                                  <th className="p-3 w-40">Message</th> {/* Increase width for better visibility */}
                              </tr>
                          </thead>
                          <tbody>
                              {encryptionLogs.map((log, index) => (
                                  <tr key={log.id} className="border-b border-gray-700">
                                      <td className="p-3 truncate">{index + 1}</td>
                                      <td className="p-3 truncate">{log.timestamp}</td>
                                      <td className="p-3 truncate">{log.algorithm}</td>
                                      <td className="p-3 truncate">{log.operation}</td>
                                      <td className="p-3 truncate">{log.type}</td>
                                      <td className="p-3">
                                          {log.status === 'success' ? (
                                              <span className="flex items-center text-green-500">
                                                  <CheckCircle className="h-4 w-4 mr-2" />
                                                  Success
                                              </span>
                                          ) : (
                                              <span className="flex items-center text-red-500">
                                                  <XCircle className="h-4 w-4 mr-2" />
                                                  Failed
                                              </span>
                                          )}
                                      </td>
                                      <td className="p-3 truncate">{log.size}</td>
                                      <td className="p-3 truncate">{log.duration}</td>
                                      <td className="p-3 truncate">{log.message}</td>  
                                  </tr>
                              ))}
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          <div className="pt-16 flex-1"></div>
      </div>

      {/* Footer */}
      <footer className="fixed bottom-0 left-0 right-0 bg-gray-800 dark:bg-gray-900 p-4 text-center">
        <p>&copy; 2024 Advanced Encryption Suite. All rights reserved.</p>
        <small>Develeloped by Nuru The_geek</small>
      </footer>
    </div>
    </div>
  );
};

export default EncryptionDashboard;
